import React from "react";
import UserMenu from '../../containers/common/UserMenu';
import styles from "../../css/header.less";

class Header extends React.Component {
    getCustomHeader = (customHeaderHTML) => {
        return (
            <div className="header" dangerouslySetInnerHTML={{__html: customHeaderHTML}}/>
        )
    };

    getMobileHeader = (customHeaderHTML) => {
        const mobileCustomHTML = customHeaderHTML && <div className="farm-custom" dangerouslySetInnerHTML={{__html: customHeaderHTML}}/>
        return (
            <div className="header">
                <div className="container">
                    <UserMenu />
                    <div className="farm-name">{this.props.staticData.farmName}</div>
                    {mobileCustomHTML}
                </div>
            </div>
        )
    };

    getHeader = () => {
        const bgColor = this.props.staticData.farmBackgroundColor ? this.props.staticData.farmBackgroundColor.toLowerCase() : "ffffff";
        const addBorder = bgColor === 'ffffff' || bgColor === "fff";
        return (
            <div className={"header" + (addBorder ? " add-border" : "")} style={{backgroundColor: "#" + this.props.staticData.farmBackgroundColor}}>
                <div className="container">
                    <a className="logo-image" href={this.props.staticData.farmWebSiteUrl} target="_blank">
                        <img src={this.props.staticData.logoUrl} />
                    </a>
                </div>
            </div>
        )
    };

    render() {
        const MOBILE_HEADER_TAG = '<!-- MOBILE HEADER TAG -->';
        const customHeaderHTML = (this.props.staticData.customHeaderHTML && this.props.staticData.customHeaderHTML !== '') ?
            this.props.staticData.customHeaderHTML.split(MOBILE_HEADER_TAG)[this.props.clientViewPort.isXs ? 1 : 0] : undefined;
        if (this.props.clientViewPort.isXs)
            return this.getMobileHeader(customHeaderHTML);
        if (customHeaderHTML)
            return this.getCustomHeader(customHeaderHTML);
        return this.getHeader();
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js